import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { useClient } from "../../ClientContext";
import { PortalClientError } from "../../types";
import { JsonApiResponse } from "../types";
import { Application } from "./types";

const useApplication = <TData extends {} = JsonApiResponse<Application>>(
  applicationId: string,
  queryOptions?: UseQueryOptions<
    JsonApiResponse<Application>,
    PortalClientError,
    TData
  >
) => {
  const client = useClient();

  return useQuery<JsonApiResponse<Application>, PortalClientError, TData>(
    ["applications", applicationId],
    () => client.get(`/applications/${applicationId}`),
    {
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  );
};

export default useApplication;
